// extracted by mini-css-extract-plugin
export default {"navContainer":"NavBar_navContainer__SbYrW","homecontainer":"NavBar_homecontainer__E0QQS","btnm":"NavBar_btnm__AkpqH","imgcontainer":"NavBar_imgcontainer__XCExx"};